import { render, staticRenderFns } from "./PolTypeMenu.vue?vue&type=template&id=32bab772&"
import script from "./PolTypeMenu.vue?vue&type=script&lang=js&"
export * from "./PolTypeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports